function ProjectBox({projectLink,projectDescription,projectName}) {
	return (
		<div>
			<a
				href={projectLink}
                target="_blank"
                rel="noreferrer"
			>
				<div className="post">
					<div className="post-preview">
						<h6 className="post-title">{projectName}</h6>
						<p className="post-intro">
							{projectDescription}
						</p>
					</div>
				</div>
			</a>
		</div>
	);
}


export default ProjectBox;